import React, { useState } from "react";
import "./Gallery.css"; // We'll style with this file

const images = [
  { src: "/imagesgallery/gallery01.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery02.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery03.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery04.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery05.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery06.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery07.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery08.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery09.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery10.jpeg", alt: "Gallery" },
 
  // Add more images gallery01
];

function Gallery() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <>
      <div className="gallery-grid">
        {images.map((img, index) => (
          <img
            key={index}
            src={img.src}
            alt={img.alt}
            onClick={() => setSelectedImg(img.src)}
            className="gallery-image"
          />
        ))}
      </div>

      {selectedImg && (
        <div className="lightbox" onClick={() => setSelectedImg(null)}>
          <img src={selectedImg} alt="Zoomed" className="lightbox-image" />
        </div>
      )}
    </>
  );
}

export default Gallery;
